import { TokenTypes } from 'types';

export const determineTokenDecimals = (token?: TokenTypes) => {
  if (token === 'dai' || token === 'arch' || token === 'ousd') return 18;
  return 6;
};
